import { Check, ChevronRight, X } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { TableCell, TableRow } from 'src/components/ui/table';
import { pickColor } from '../utils';
import ClientCreationComponent from 'src/pages/client-management/components/client-creation/client-creation-component';
import { useActiveClient } from 'src/redux/active-client/use-active-client';
import { Client } from '../types/client.types';

interface ClientManagementTableRowProps {
  client: Client;
  isCreation?: boolean;
}


const ClientManagementTableRow: React.FC<ClientManagementTableRowProps> = ({
  client,
  isCreation,
}) => {
  const { setClient } = useActiveClient();
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (isCreation) {
      setExpanded(false);
    }
  }, [isCreation]);

  const handleSelect = () => {
    setExpanded(!expanded);
    setClient(client);
  };

  const clientColor = pickColor(client.title, ['bg-green-501', 'bg-blue-500', 'bg-red-501', 'bg-yellow-500', 'bg-purple-500', 'bg-orange-500', 'bg-gray-500']);
  return (
    <>
      <TableRow
        className="border-b border-gray-201 bg-white overflow-visible sticky top-0"
        onClick={handleSelect}
      >
        <TableCell className='w-[3%] min-w-[30px] py-1.5'>
          <ChevronRight className={`h-4 w-4 text-gray-500 animate-in duration-300 ease-in-out ${expanded ? 'rotate-90' : ''}`} />
        </TableCell>
        <TableCell>
          <div className='flex flex-row gap-2 items-center py-2'>
            <div className='w-8 h-8 rounded-full'>
              {client.brand && (
                <img
                  src={`${client.brand}`}
                  className='w-full h-full object-cover'
                />
              )}
              {!client.brand && <div className={`w-full h-full object-cover ${clientColor} rounded-full`} />}
            </div>
            <div className='text-sm font-bold flex flex-col'>
              <div className='text-sm font-bold'>
                {client.title}
              </div>
              <div className='!text-xs font-normal text-gray-500'>
                {client.companies && client.companies.map((company) => company.company_name).join(', ')}
              </div>
            </div>
          </div>
        </TableCell>
        <TableCell>
          <div className='text-sm'>
            {client.users.length}
            {' '}
            Users
          </div>
        </TableCell>
        <TableCell>
          <div className='text-sm'>
            {client.total_accounts}
            {' '}
            Acccounts
          </div>
        </TableCell>
        <TableCell>
          <div className='text-sm'>
            {client.total_campaigns}
            {' '}
            Campaigns
          </div>
        </TableCell>
        <TableCell>
          <div className='text-sm flex flex-col'>
            <div className='flex flex-row items-center text-xs text-gray-500'>
              {client.auto_add_accounts ? <Check className='size-3 mr-1' /> : <X className='size-3 mr-1' />}
              Auto+ Accounts
            </div>
            <div className='flex flex-row items-center text-xs text-gray-500'>
              {client.auto_add_campaigns ? <Check className='size-3 mr-1' /> : <X className='size-3 mr-1' />}
              Auto+ Campaigns
            </div>
          </div>
        </TableCell>
      </TableRow>
      {expanded && (
        <TableRow className='overflow-visible'>
          <TableCell
            colSpan={6}
            className='p-0 overflow-visible'
          >
            <ClientCreationComponent
              isCreate={false}
            />
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default ClientManagementTableRow;
